export default Object.freeze({
  Draft: 1,
  PendingReview: 2,
  Approved: 3,
  Paid: 4,
  Cancelled: 5,
});
